module.exports = __webpack_public_path__ + "img/ProSafe-powerebyworldvue-white.6ad98ba0.svg";